export default __webpack_public_path__ + "static/media/Hana ga Saku Michi.7a89808d.mp3";